import React, { ReactNode } from 'react';
import { ConfigContextProvider as ConfigContext } from '@cp/shared/config';
import { useInjection } from '@cp/shared/di';
import { CONFIG_MANAGER_TOKEN } from './const';

export const ConfigContextProvider = ({ children }: { children: ReactNode }) => {
  const manager = useInjection(CONFIG_MANAGER_TOKEN);
  return <ConfigContext value={manager}>{children}</ConfigContext>;
};
